import * as E from 'fp-ts/Either';
import { useEffect, useMemo, useState } from 'react';
import { useAuth } from '../auth/AuthContext';
import {
  LicenseLogsResponse,
  licenseFailureLogs,
  licenseLogs,
} from '../api/logs';

export const useLogPager = (
  type: 'licenses' | 'failures',
  from: Date | null,
  to: Date | null,
  forceRefresh: number, // this one is used just to re-trigger the useEffect
  app?: string | null,
  cursor?: string | null
) => {
  const auth = useAuth();
  const [response, setResponse] = useState<LicenseLogsResponse | null>(null);
  const [error, setError] = useState<string | null>(null);

  const dateRange = useMemo(() => {
    return from && to
      ? { from: from.toISOString(), to: to.toISOString() }
      : null;
  }, [from, to]);

  useEffect(() => {
    if (!auth?.token) {
      return;
    }
    const pager = type === 'licenses' ? licenseLogs : licenseFailureLogs;
    pager(auth.token, dateRange, app, cursor).then((result): void => {
      if (E.isLeft(result)) {
        setError(
          result.left.helpMessage ??
            result.left.message ??
            'Failed to fetch logs'
        );
        return;
      }

      setResponse(result.right);
    });
  }, [auth?.token, dateRange, app, cursor, type, forceRefresh]);

  // Logs is raw from the API, chartData is formatted for chart.js
  return { ...response, error };
};
